module.exports = __webpack_public_path__ + "img/phone.25e4db06.png";